interface Props {
  title?: string;
  description?: string;
}

export default function EmptyState({ title, description = 'Nothing here yet.' }: Props) {
  return (
    <div className="ln-empty">
      {title ? <div className="ln-empty-title">{title}</div> : null}
      <div>{description}</div>
    </div>
  );
}
